<div class="mat-typography">
  <h3 *ngIf="!!title && title.length > 0">{{ title }}</h3>
  <p *ngIf="!!message && message.length > 0">{{ message }}</p>
</div>
